import axios from 'axios'
import createAuthRefreshInterceptor from 'axios-auth-refresh'
import store from '../store'
import i18n from '@/lang/i18n'
import LogRocket from 'logrocket'
import { refreshAuthLogic } from '../api/refreshAuth'

const api = axios.create({
  baseURL: process.env.MIX_DR_API_HOST_NAME
})

// -- HELPERS --

function injectAuthHeaders(config) {
  const token = store.state.auth.token
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  config.headers['X-From'] = window.location.href
  return config
}

function handleMaintenance(err) {
  const status = err.response?.status
  if (status === 503) {
    const data = err.response.data?.data || null
    console.log('Maintenance mode detected', JSON.stringify(data, null, 2))
    // set maintenance data in store
    const maintenanceData = {
      startDateTime: data.start_date_time,
      endDateTime: data.end_date_time,
      message: i18n.t('maintenance_message'),
      isMaintenance: true
    }
    store.dispatch('maintenance/setMaintenance', maintenanceData)
    // if Vue.router is not null, push to maintenance page
    if (Vue.router && Vue.router.currentRoute.name !== 'Maintenance') {
      console.log('Pushing to Maintenance page')
      Vue.router.push({ name: 'Maintenance' })
    }
    return true
  }
  return false
}

async function handleNetworkOrApiError(err) {
  if (!navigator.onLine) {
    const msg = i18n.t('not_connected_to_the_network')
    Vue.dialog.alert(msg, { okText: 'OK', backdropClose: true })
    return true
  }

  if (err.request && !err.response) {
    Vue.router.push({ name: 'ErrorCheck' })
    return true
  }

  return false
}

// -- INTERCEPTORS --

// Request: inject headers
api.interceptors.request.use(
  async config => {
    return injectAuthHeaders(config)
  },
  error => Promise.reject(error)
)

// Response: maintenance → auth → network → fallback
api.interceptors.response.use(
  response => response,
  async error => {
    // 1) maintenance mode
    if (handleMaintenance(error)) {
      return Promise.reject(error)
    }

    // 2) LogRocket capture
    LogRocket.captureException(error, {
      tags: { category: 'API ERROR' }
    })

    // 3) network or API-failure
    if (await handleNetworkOrApiError(error)) {
      return Promise.reject(error)
    }

    // 4) everything else
    return Promise.reject(error)
  }
)

createAuthRefreshInterceptor(api, refreshAuthLogic)

export default api
